// Comentarios y soporte: cualquiera los envía, solo el admin los consulta.
import {api} from './api';

export const feedbackService={
  send: (feedback)=> api('/feedback',{method: 'POST',body: feedback}),
  list: async ()=> (await api('/feedback')).feedback,
  setStatus: (id,status)=> api(`/feedback/${id}`,{method: 'PUT',body: {status}}),
  remove: (id)=> api(`/feedback/${id}`,{method: 'DELETE'}),
  attachmentUrl: (feedbackId,attachmentId)=> `/api/feedback/${feedbackId}/attachments/${attachmentId}`,
};

export const MAX_ATTACHMENTS=3;
const MAX_DATA_LENGTH=1400000; // el mismo límite que valida el Worker
const MAX_IMAGE_SIDE=1600;
const ALLOWED_TYPES=['image/png','image/jpeg','image/webp','application/pdf'];

const readAsDataUrl=(file)=> new Promise((resolve,reject)=>{
  const reader=new FileReader();
  reader.onload=()=> resolve(reader.result);
  reader.onerror=()=> reject(new Error(`No se pudo leer ${file.name}`));
  reader.readAsDataURL(file);
});

// Las fotos y capturas se reducen a JPEG de máximo 1600 px para que quepan en el límite.
async function shrinkImage(file) {
  const bitmap=await createImageBitmap(file);
  const scale=Math.min(1,MAX_IMAGE_SIDE/Math.max(bitmap.width,bitmap.height));
  const canvas=document.createElement('canvas');
  canvas.width=Math.round(bitmap.width*scale);
  canvas.height=Math.round(bitmap.height*scale);
  const context=canvas.getContext('2d');
  context.fillStyle='#ffffff';
  context.fillRect(0,0,canvas.width,canvas.height);
  context.drawImage(bitmap,0,0,canvas.width,canvas.height);
  return {
    name: file.name.replace(/\.[^.]+$/,'')+'.jpg',
    data: canvas.toDataURL('image/jpeg',0.8),
  };
}

export async function prepareAttachment(file) {
  if (!ALLOWED_TYPES.includes(file.type)) throw new Error(`${file.name}: solo se permiten imágenes y PDF`);
  const prepared=file.type.startsWith('image/')
    ? await shrinkImage(file)
    : {name: file.name,data: await readAsDataUrl(file)};
  if (prepared.data.length>MAX_DATA_LENGTH) throw new Error(`${file.name} pesa más de 1 MB`);
  return prepared;
}
